import TLDs from 'tlds'

import {TapperFacetDefinition} from './types'

// Each regex begins with a `(^|\s|\()` capture group: a backwards-compatible
// alternative to lookbehind (Safari < 16.4 throws on lookbehind at parse time).
// The boundary char is captured into m[1]; util.ts strips it so positions and
// `raw` reflect the facet itself.
export const mention = /(^|\s|\()@([a-zA-Z0-9.-]+)\b/g
export const emoji = /(^|\s|\():([a-zA-Z0-9_]+):/g
export const tag =
  /(^|\s|\()[#＃]((?!\ufe0f)[^\s\u00AD\u2060\u200A\u200B\u200C\u200D\u20e2]*[^\d\s\p{P}\u00AD\u2060\u200A\u200B\u200C\u200D\u20e2]+[^\s\u00AD\u2060\u200A\u200B\u200C\u200D\u20e2\p{P}]*)?/gu

// Built once at module load and shared by every Tapper instance.
const TLD_SET = new Set(TLDs)

// Bare-domain matches must end in a real TLD, mirroring the validation
// RichText's detectFacets applies after its identical URL_REGEX matches.
// Without this, dotted abbreviations like `P.S.` or `e.g.` highlight in the
// editor but never become facets. `https?://` matches (m[3]) skip validation,
// same as RichText. The TLD check is deliberately case-sensitive: RichText's
// isValidDomain is too (`BSKY.APP` never facets), so don't lowercase here.
//
// Capture indices are load-bearing: validate reads the domain from m[5]. We
// can't use the (?<domain>) name at runtime — bundlers (Babel's
// transform-named-capturing-groups-regex) strip the name from the regex source
// when an app bundles us, so m.groups.domain reads back undefined. If you
// reorder or add capture groups in the pattern, update the m[5] index below.
export const url: TapperFacetDefinition = {
  pattern:
    /(^|\s|\()((https?:\/\/[\S]+)|((?<domain>[a-z][a-z0-9]*(\.[a-z0-9]+)+)[\S]*))/gim,
  validate: m => {
    if (m[3]) return true
    const domain = m[5]
    if (!domain) return false
    return TLD_SET.has(domain.slice(domain.lastIndexOf('.') + 1))
  },
}
